import { AsyncLocalStorage } from 'node:async_hooks';

/**
 * Per-request context for MCP tool handlers. Threaded via AsyncLocalStorage so
 * handler bodies don't have to take ctx as a parameter — `mcpApiRequest()`
 * pulls it from `currentToolCtx()`.
 */
export type ToolCtx = {
  apiUrl: string;
  apiToken: string;
};

const storage = new AsyncLocalStorage<ToolCtx>();

export function withToolCtx<T>(ctx: ToolCtx, fn: () => Promise<T>): Promise<T> {
  return storage.run(ctx, fn);
}

export function currentToolCtx(): ToolCtx | undefined {
  return storage.getStore();
}
